<template>
<div class="wrap p-1">
    <div class="row border-bottom mx-1">
        <div class="col-12 py-2">
            <h4>List Files</h4>
        </div>
    </div>
    <div class="row border-bottom mx-1">
        <div class="col-12 py-2">
            <button class="pointer" @click.prevent="viewDetailFile('zip')">
                <span class="icon">
                    <svg id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m486.644 3.327h-324.581c11.652 0 22.075 7.247 26.131 18.171l16.577 51.331c5.507 14.825 19.654 24.663 35.469 24.663h243.883c15.396 0 27.877 12.481 27.877 27.877v-96.686c0-13.946-11.41-25.356-25.356-25.356z" fill="#fec458"/><g><g><path d="m303.169 72.83-16.577-51.331c-4.056-10.923-14.479-18.171-26.131-18.171h-98.398c11.652 0 22.075 7.247 26.131 18.171l16.577 51.331c5.507 14.825 19.653 24.663 35.469 24.663h98.398c-15.815-.001-29.962-9.838-35.469-24.663z" fill="#f9ab49"/></g></g><path d="m484.123 90.801h-237.191c-15.816 0-29.962-9.837-35.469-24.663l-16.577-44.64c-4.056-10.923-14.479-18.171-26.131-18.171h-140.878c-15.396 0-27.877 12.481-27.877 27.877v353.849c0 15.395 12.48 27.876 27.876 27.876h456.248c15.396 0 27.877-12.481 27.877-27.877v-266.374c-.001-15.396-12.482-27.877-27.878-27.877z" fill="#ffe181"/><path d="m89.217 385.053v-353.849c0-15.396 12.481-27.877 27.877-27.877h-89.217c-15.396.001-27.877 12.481-27.877 27.877v353.849c0 15.395 12.481 27.876 27.876 27.876h89.217c-15.395-.001-27.876-12.481-27.876-27.876z" fill="#fec458"/><path d="m408.517 251.377h-305.034c-18.245 0-33.173 14.928-33.173 33.173v190.949c0 18.245 14.928 33.173 33.173 33.173h305.033c18.245 0 33.173-14.928 33.173-33.173v-190.949c.001-18.245-14.927-33.173-33.172-33.173z" fill="#9dc6fb"/><path d="m144.542 475.499v-190.949c0-18.245 14.928-33.173 33.173-33.173h-74.231c-18.245 0-33.173 14.928-33.173 33.173v190.949c0 18.245 14.928 33.173 33.173 33.173h74.231c-18.246.001-33.173-14.928-33.173-33.173z" fill="#80b4fb"/><g fill="#dfebfa"><path d="m151.425 426.75h53.893c5.944 0 9.312 7.133 9.312 13.472 0 6.341-3.368 13.474-9.312 13.474h-84.405c-6.34 0-8.916-3.368-8.916-8.123 0-3.17 1.189-7.133 3.368-10.897l55.874-98.869h-45.967c-5.944 0-9.312-6.341-9.312-13.474 0-6.539 2.774-13.474 9.312-13.474h76.48c5.944 0 8.916 3.368 8.916 8.123 0 3.17-1.189 6.935-3.368 10.898z"/><path d="m239.254 318.171c0-6.538 7.727-9.312 15.454-9.312 7.728 0 15.455 2.775 15.455 9.312v126.014c0 6.34-7.727 9.51-15.455 9.51-7.727 0-15.454-3.17-15.454-9.51z"/><path d="m353.777 308.859h-41.014c-6.935 0-11.491 4.359-11.491 9.312v126.014c0 6.34 7.727 9.51 15.454 9.51 7.728 0 15.455-3.17 15.455-9.51v-37.942h19.615c27.343 0 48.741-17.535 48.741-50.822v-.991c0-33.286-20.606-45.571-46.76-45.571zm15.851 48.94c0 13.472-6.737 19.813-17.832 19.813h-19.616v-41.806h19.615c11.095 0 17.832 6.34 17.832 19.813v2.18z"/></g></g></svg>
                </span>
                <span class="name">File ZIP</span>
            </button>
        </div>
    </div>
    <div class="row border-bottom mx-1">
        <div class="col-12 py-2">
            <button class="pointer" @click.prevent="viewDetailFile('rar')">
                <span class="icon">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 303.188 303.188" style="enable-background:new 0 0 303.188 303.188;" xml:space="preserve">
                        <g>
                            <polygon style="fill:#E4E4E4;" points="219.821,0 32.842,0 32.842,303.188 270.346,303.188 270.346,50.525 	"/>
                            <polygon style="fill:#FB9200;" points="227.64,25.263 32.842,25.263 32.842,0 219.821,0 	"/>
                            <g>
                                <rect x="185.948" y="87.902" style="fill:#A4A9AD;" width="14.419" height="62.587"/>
                                <g>
                                    <polygon style="fill:#D1D3D3;" points="203.589,133.525 182.727,137.298 182.727,143.689 203.589,139.916 			"/>
                                    <polygon style="fill:#D1D3D3;" points="203.589,120.584 182.727,124.357 182.727,130.748 203.589,126.976 			"/>
                                    <polygon style="fill:#D1D3D3;" points="203.589,107.644 182.727,111.416 182.727,117.807 203.589,114.035 			"/>
                                    <polygon style="fill:#D1D3D3;" points="203.589,94.703 182.727,98.475 182.727,104.866 203.589,101.093 			"/>
                                </g>
                                <rect x="188.365" y="155" style="fill:#A4A9AD;" width="9.585" height="18.042"/>
                                <polygon style="fill:#A4A9AD;" points="182.727,147.952 163.274,155.282 104.368,155.282 111.416,167.123 163.274,167.123 
                                    182.727,159.792 203.589,159.792 203.589,147.952 		"/>
                                <polygon style="fill:#A4A9AD;" points="182.727,90.44 163.274,83.11 104.368,83.11 111.416,71.27 163.274,71.27 182.727,78.599 
                                    203.589,78.599 203.589,90.44 		"/>
                                <g>
                                    <rect x="89.693" y="83.11" style="fill:#FB9200;" width="71.052" height="72.171"/>
                                    <g>
                                        <rect x="100.176" y="92.185" style="fill:#FF671B;" width="50.086" height="22.828"/>
                                        <rect x="117.142" y="98.818" style="fill:#FFFFFF;" width="16.154" height="3.953"/>
                                    </g>
                                    <g>
                                        <rect x="100.176" y="123.38" style="fill:#FF671B;" width="50.086" height="22.827"/>
                                        <rect x="117.142" y="130.013" style="fill:#FFFFFF;" width="16.154" height="3.954"/>
                                    </g>
                                </g>
                                <rect x="182.727" y="167.123" style="fill:#A4A9AD;" width="20.862" height="11.84"/>
                            </g>
                            <g>
                                <path style="fill:#A4A9AD;" d="M99.11,256.412v17.459H86.147v-47.979h15.72c13.04,0,19.559,4.726,19.559,14.177
                                    c0,5.558-2.713,9.857-8.139,12.898l13.98,20.905h-14.702l-10.174-17.459L99.11,256.412L99.11,256.412z M99.11,246.666h2.429
                                    c4.529,0,6.793-2.002,6.793-6.006c0-3.303-2.221-4.956-6.662-4.956h-2.56V246.666z"/>
                                <path style="fill:#A4A9AD;" d="M161.069,273.871l-2.361-8.992h-15.59l-2.428,8.992h-14.243l15.655-48.176h17.295l15.85,48.176
                                    H161.069z M156.017,254.246l-2.068-7.876c-0.48-1.751-1.066-4.015-1.756-6.794c-0.688-2.778-1.143-4.769-1.361-5.973
                                    c-0.197,1.116-0.586,2.954-1.164,5.513c-0.58,2.56-1.867,7.603-3.857,15.129h10.206V254.246z"/>
                                <path style="fill:#A4A9AD;" d="M193.396,256.412v17.459h-12.963v-47.979h15.72c13.039,0,19.559,4.726,19.559,14.177
                                    c0,5.558-2.713,9.857-8.139,12.898l13.98,20.905h-14.702l-10.174-17.459L193.396,256.412L193.396,256.412z M193.396,246.666h2.428
                                    c4.529,0,6.794-2.002,6.794-6.006c0-3.303-2.221-4.956-6.662-4.956h-2.56V246.666z"/>
                            </g>
                            <polygon style="fill:#D1D3D3;" points="219.821,50.525 270.346,50.525 219.821,0 	"/>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        </svg>
                </span>
                <span class="name">File RAR</span>
            </button>
        </div>
    </div>
    <div class="row border-bottom mx-1">
        <div class="col-12 py-2">
            <button class="pointer" @click.prevent="viewDetailFile('doc')">
                <span class="icon">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <path style="fill:#E2E5E7;" d="M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"/>
                        <path style="fill:#B0B7BD;" d="M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"/>
                        <polygon style="fill:#CAD1D8;" points="480,224 384,128 480,128 "/>
                        <path style="fill:#50BEE8;" d="M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16
                            V416z"/>
                        <g>
                            <path style="fill:#FFFFFF;" d="M92.576,384c-4.224,0-8.832-2.32-8.832-7.936v-72.656c0-4.608,4.608-7.936,8.832-7.936h29.296
                                c58.464,0,57.168,88.528,1.136,88.528H92.576z M100.64,311.072v57.312h21.232c34.544,0,36.064-57.312,0-57.312H100.64z"/>
                            <path style="fill:#FFFFFF;" d="M228,385.28c-23.664,1.024-48.24-14.72-48.24-46.064c0-31.472,24.56-46.944,48.24-46.944
                                c22.384,1.136,45.792,16.624,45.792,46.944C273.792,369.552,250.384,385.28,228,385.28z M226.592,308.912
                                c-14.336,0-29.936,10.112-29.936,30.32c0,20.096,15.616,30.336,29.936,30.336c14.72,0,30.448-10.24,30.448-30.336
                                C257.04,319.008,241.312,308.912,226.592,308.912z"/>
                            <path style="fill:#FFFFFF;" d="M288.848,339.088c0-24.688,15.488-45.92,44.912-45.92c11.136,0,19.968,3.328,29.296,11.392
                                c3.456,3.184,3.84,8.816,0.384,12.4c-3.456,3.056-8.704,2.688-11.776-0.384c-5.232-5.504-10.608-7.024-17.904-7.024
                                c-19.696,0-29.152,13.952-29.152,29.552c0,15.872,9.328,30.448,29.152,30.448c7.296,0,14.08-2.96,19.968-8.192
                                c3.952-3.072,9.456-1.552,11.76,1.536c2.048,2.816,3.056,7.552-1.408,12.016c-8.96,8.336-19.696,10-30.336,10
                                C302.8,384.912,288.848,363.776,288.848,339.088z"/>
                        </g>
                        <path style="fill:#CAD1D8;" d="M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"/>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        </svg>
                </span>
                <span class="name">File DOC</span>
            </button>
        </div>
    </div>
    <div class="row border-bottom mx-1">
        <div class="col-12 py-2">
            <button class="pointer" @click.prevent="viewDetailFile('exl')">
                <span class="icon">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <path style="fill:#4CAF50;" d="M294.656,13.014c-2.531-2.056-5.863-2.842-9.045-2.133l-277.333,64
                                C3.397,76.003-0.047,80.369,0,85.377v362.667c0.002,5.263,3.843,9.739,9.045,10.539l277.333,42.667
                                c5.823,0.895,11.269-3.099,12.164-8.921c0.082-0.535,0.124-1.076,0.124-1.617V21.377C298.676,18.124,297.199,15.045,294.656,13.014
                                z"/>
                            <path style="fill:#4CAF50;" d="M501.334,458.71H288c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667
                                h202.667V74.71H288c-5.891,0-10.667-4.776-10.667-10.667S282.109,53.377,288,53.377h213.333c5.891,0,10.667,4.776,10.667,10.667
                                v384C512,453.935,507.225,458.71,501.334,458.71z"/>
                        </g>
                        <g>
                            <path style="fill:#FAFAFA;" d="M202.667,352.044c-3.678,0-7.096-1.895-9.045-5.013L86.955,176.364
                                c-3.279-4.894-1.969-11.52,2.925-14.799s11.52-1.969,14.799,2.925c0.129,0.192,0.251,0.388,0.367,0.588l106.667,170.667
                                c3.11,5.003,1.576,11.58-3.427,14.691C206.599,351.484,204.653,352.041,202.667,352.044z"/>
                            <path style="fill:#FAFAFA;" d="M96,352.044c-5.891-0.012-10.657-4.797-10.645-10.688c0.004-1.992,0.566-3.943,1.621-5.632
                                l106.667-170.667c2.954-5.097,9.481-6.834,14.577-3.88c5.097,2.954,6.834,9.481,3.88,14.577c-0.116,0.2-0.238,0.396-0.367,0.588
                                L105.067,347.009C103.119,350.142,99.69,352.047,96,352.044z"/>
                        </g>
                        <g>
                            <path style="fill:#4CAF50;" d="M373.334,458.71c-5.891,0-10.667-4.776-10.667-10.667v-384c0-5.891,4.776-10.667,10.667-10.667
                                c5.891,0,10.667,4.776,10.667,10.667v384C384,453.935,379.225,458.71,373.334,458.71z"/>
                            <path style="fill:#4CAF50;" d="M501.334,394.71H288c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667
                                h213.333c5.891,0,10.667,4.776,10.667,10.667C512,389.935,507.225,394.71,501.334,394.71z"/>
                            <path style="fill:#4CAF50;" d="M501.334,330.71H288c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667
                                h213.333c5.891,0,10.667,4.776,10.667,10.667C512,325.935,507.225,330.71,501.334,330.71z"/>
                            <path style="fill:#4CAF50;" d="M501.334,266.71H288c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667
                                h213.333c5.891,0,10.667,4.776,10.667,10.667C512,261.935,507.225,266.71,501.334,266.71z"/>
                            <path style="fill:#4CAF50;" d="M501.334,202.71H288c-5.891,0-10.667-4.776-10.667-10.667s4.776-10.667,10.667-10.667h213.333
                                c5.891,0,10.667,4.776,10.667,10.667S507.225,202.71,501.334,202.71z"/>
                            <path style="fill:#4CAF50;" d="M501.334,138.71H288c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667
                                h213.333c5.891,0,10.667,4.776,10.667,10.667C512,133.935,507.225,138.71,501.334,138.71z"/>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </span>
                <span class="name">File Excel</span>
            </button>
        </div>
    </div>
    <div class="row border-bottom mx-1">
        <div class="col-12 py-2">
            <button class="pointer" @click.prevent="viewDetailFile('dpf')">
                <span class="icon">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 56 56" style="enable-background:new 0 0 56 56;" xml:space="preserve">
                        <g>
                            <path style="fill:#E9E9E0;" d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074
                                c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"/>
                            <polygon style="fill:#D9D7CA;" points="37.5,0.151 37.5,12 49.349,12 	"/>
                            <path style="fill:#CC4B4C;" d="M19.514,33.324L19.514,33.324c-0.348,0-0.682-0.113-0.967-0.326
                                c-1.041-0.781-1.181-1.65-1.115-2.242c0.182-1.628,2.195-3.332,5.985-5.068c1.504-3.296,2.935-7.357,3.788-10.75
                                c-0.998-2.172-1.968-4.99-1.261-6.643c0.248-0.579,0.557-1.023,1.134-1.215c0.228-0.076,0.804-0.172,1.016-0.172
                                c0.504,0,0.947,0.649,1.261,1.049c0.295,0.376,0.964,1.173-0.373,6.802c1.348,2.784,3.258,5.62,5.088,7.562
                                c1.311-0.237,2.439-0.358,3.358-0.358c1.566,0,2.515,0.365,2.902,1.117c0.32,0.622,0.189,1.349-0.39,2.16
                                c-0.557,0.779-1.325,1.191-2.22,1.191c-1.216,0-2.632-0.768-4.211-2.285c-2.837,0.593-6.15,1.651-8.828,2.822
                                c-0.836,1.774-1.637,3.203-2.383,4.251C21.273,32.654,20.389,33.324,19.514,33.324z M22.176,28.198
                                c-2.137,1.201-3.008,2.188-3.071,2.744c-0.01,0.092-0.037,0.334,0.431,0.692C19.685,31.587,20.555,31.19,22.176,28.198z
                                M35.813,23.756c0.815,0.627,1.014,0.944,1.547,0.944c0.234,0,0.901-0.01,1.21-0.441c0.149-0.209,0.207-0.343,0.23-0.415
                                c-0.123-0.065-0.286-0.197-1.175-0.197C37.12,23.648,36.485,23.67,35.813,23.756z M28.343,17.174
                                c-0.715,2.474-1.659,5.145-2.674,7.564c2.09-0.811,4.362-1.519,6.496-2.02C30.815,21.15,29.466,19.192,28.343,17.174z
                                M27.736,8.712c-0.098,0.033-1.33,1.757,0.096,3.216C28.781,9.813,27.779,8.698,27.736,8.712z"/>
                            <path style="fill:#CC4B4C;" d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"/>
                            <g>
                                <path style="fill:#FFFFFF;" d="M17.385,53h-1.641V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205
                                    c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306
                                    c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656
                                    s-0.921,0.232-1.449,0.232h-1.217V53z M17.385,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103
                                    c0.196-0.068,0.376-0.18,0.54-0.335c0.164-0.155,0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032
                                    c0-0.164-0.023-0.354-0.068-0.567c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492
                                    c-0.255-0.132-0.593-0.198-1.012-0.198H17.385z"/>
                                <path style="fill:#FFFFFF;" d="M32.219,47.682c0,0.829-0.089,1.538-0.267,2.126s-0.403,1.08-0.677,1.477s-0.581,0.709-0.923,0.937
                                    s-0.672,0.398-0.991,0.513c-0.319,0.114-0.611,0.187-0.875,0.219C28.222,52.984,28.026,53,27.898,53h-3.814V42.924h3.035
                                    c0.848,0,1.593,0.135,2.235,0.403s1.176,0.627,1.6,1.073s0.74,0.955,0.95,1.524C32.114,46.494,32.219,47.08,32.219,47.682z
                                    M27.352,51.797c1.112,0,1.914-0.355,2.406-1.066s0.738-1.741,0.738-3.09c0-0.419-0.05-0.834-0.15-1.244
                                    c-0.101-0.41-0.294-0.781-0.581-1.114s-0.677-0.602-1.169-0.807s-1.13-0.308-1.914-0.308h-0.957v7.629H27.352z"/>
                                <path style="fill:#FFFFFF;" d="M36.266,44.168v3.172h4.211v1.121h-4.211V53h-1.668V42.924H40.9v1.244H36.266z"/>
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </span>
                <span class="name">File DPF</span>
            </button>
        </div>
    </div>
</div>
</template>

<script src="./index.js"></script>

<style lang="scss" scoped>
.wrap{
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 100%;
    background: #fff;
    height: 100%;
    .border-bottom{
        &:last-child{
            border-bottom: 0px !important;
        }
    }
    button{
        border: 0px;
        background: transparent;
        >span{
            display: inline-block;
            vertical-align: middle;
        }
        .icon{
            svg{
                width: 20px;
                height: 20px;
            }
        }
    }
}
</style>